import { Currencies, Offer } from "@ribondao/shared/types";
import { useTranslation } from "react-i18next";
import EditIcon from "assets/icons/edit-icon.svg";
import { useExperiment } from "@growthbook/growthbook-react";
import { useCardGivingFees } from "@ribondao/shared/hooks";
import { GivingFeesLoader } from "./loader";
import * as S from "./styles";

export type Props = {
  currentOffer?: Offer;
  priceValue?: string;
  onEditClick?: () => void;
  tokenSymbol?: string;
  canEdit?: boolean;
};

function PriceSelection({
  currentOffer,
  priceValue,
  onEditClick,
  tokenSymbol = "USDC",
  canEdit = true,
}: Props): JSX.Element {
  const { t } = useTranslation("translation", {
    keyPrefix: "promoters.checkoutPage",
  });

  const variation = useExperiment({
    key: "payment-form",
    variations: [false, true],
  });

  const { cardGivingFees } = useCardGivingFees(
    currentOffer?.priceValue || 0,
    currentOffer?.currency.toUpperCase() as Currencies,
    currentOffer?.gateway || "stripe_global",
  );

  const price = currentOffer?.price || `${tokenSymbol} ${priceValue}`;

  const renderGivingFees = () => {
    if (!cardGivingFees) return <GivingFeesLoader />;

    return (
      <S.SmallTextInfoWrapper>
        <S.SmallTextInfo>
          {t("netDonation")}
          {cardGivingFees?.netGiving}
        </S.SmallTextInfo>
        <S.SmallTextInfo>
          {t("serviceFees")}
          {cardGivingFees?.serviceFees}
        </S.SmallTextInfo>
      </S.SmallTextInfoWrapper>
    );
  };

  return (
    <S.Container>
      <S.Offer>
        {price}
        {canEdit && (
          <S.EditButton onClick={onEditClick} type="button">
            <img src={EditIcon} alt="Edit" />
          </S.EditButton>
        )}
      </S.Offer>
      {!variation.value && renderGivingFees()}
    </S.Container>
  );
}

export default PriceSelection;
